/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/* eslint-env browser */

import ErrorName from '../error/error-name';

const abortMessage = 'Waiting for a timeout was aborted.';

/**
 * Převede čekání na timeout na promise s možností předčasného ukončení.
 * @param {number} delay Čas, po jakém dojde k vyřešení promise [ms].
 * @param {Object} [opts]
 * @param {AbortSignal} [opts.abortSignal] Signál pro předčasné přerušení.
 * @throws {AbortError} Čekání bylo předčasně ukončeno.
 * @returns {Promise.<undefined>}
 */
function promisifyTimeout(delay, { abortSignal = new AbortSignal() }) {
  return new Promise((resolve, reject) => {
    if (abortSignal.aborted) {
      const error = new Error(abortMessage);
      error.name = ErrorName.AbortError;
      throw error;
    }
    const timeout = setTimeout(() => {
      abortSignal.removeEventListener('abort', abortListener);
      return resolve();
    }, delay);
    const abortListener = () => {
      clearTimeout(timeout);
      abortSignal.removeEventListener('abort', abortListener);
      const error = new Error(abortMessage);
      error.name = ErrorName.AbortError;
      return reject(error);
    };
    abortSignal.addEventListener('abort', abortListener);
  });
}

export default promisifyTimeout;
